module.exports = __webpack_public_path__ + "img/huankuanchenggong.1e8eec1c.png";